<template>
<div class="order-details-wrapper">

  <portal target-el="#filter">
    <div class="breadcrumb">
    <div class="back-option">
      <a href="javascript:history.go(-1)">
        <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
      </a>
    </div>
    <div>
   <!-- <button @click="saveUser" class="btn btn-primary profile-save-btn"> Save </button> -->
    </div>
   </div>
  </portal>

  <div class="order-materials">
    <Tabs>
      <Tab title="Basic Information" :active="true">
        <div class="profile">
          <div class="card-row-edit">
            <div class="card-edit">
              <div class="card-edit-content row">
                <div class="col-lg-auto w150">
                  <div class="text-outer">
                    <div class="text-middle">
                      <div class="text-inner">
                        <div class="profile-name d-flex justify-content-center">
                          <span v-if="!currClient.logo_buffer">{{name.length ? name[0] : ''}}</span>
                          <div v-else class="profile-img"><img :src="getClientLogo()" alt="" class="pointer" /></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 grid">
                  <div class="col-lg-12 grid-col">
                    <label for="">Name:</label>
                    <input type="text" v-model="name" disabled="disabled">
                  </div>

                  <div class="col-lg-12 grid-col">
                    <label for="">Mobile Number:</label>
                    <input type="text" v-model="mobile" disabled="disabled">
                  </div>

                  <div class="col-lg-12 grid-col">
                    <label for="">Email ID:</label>
                    <input type="text" v-model="email" disabled="disabled">
                  </div>
                </div>

                <div class="col-lg-3" v-if="!ChangePassword">
                  <div class="text-outer">
                    <div class="text-middle">
                      <div class="text-inner grid">
                        <button class="btn btn-primary"
                        @click="ChangePassword=true">
                        Change Password
                      </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 grid" v-else>
                  <!-- <div class="col-lg-12 grid-col">
                    <label for="">Current Password:</label>
                    <input type="password" placeholder="">
                  </div> -->

                  <div class="col-lg-12 grid-col">
                    <label for="">New Password:</label>
                    <input type="password" autocomplete="off" v-model.trim.lazy="password" placeholder="**********" />
                    <div class="error" v-if=" $v.password.$dirty && !$v.password.required">
                      Password is required.
                    </div>
                    <div class="error" v-if="$v.password.$dirty && !$v.password.strongPassword">
                      The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc).
                    </div>
                  </div>

                  <div class="col-lg-12 grid-col">
                    <label for="">Confirm Password:</label>
                    <input type="password" autocomplete="off"
                    v-model.trim.lazy="repeatPassword" placeholder="**********" />
                    <div class="error"
                    v-if="$v.repeatPassword.$dirty && !$v.repeatPassword.sameAsPassword">
                        Passwords must be identical.
                    </div>
                  </div>

                  <div class="col-lg-12 pull-right"
                  v-on:closeEdit="ChangePassword=false">
                    <button class="btn btn-primary" @click="changePassword">
                    Save
                  </button>
                  <div class="password-note">
                    <label for="">Please login again once password is changed.</label>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab>
    </Tabs>
  </div>
</div>
</template>

<script>
import { helpers, required, sameAs, minLength } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { passwordPattern } from 'pando-constants';

const strongPassword = helpers.regex('strongPassword', passwordPattern);

export default {

  data() {
    return {
      name: null,
      email: null,
      mobile: null,
      ChangePassword: false,
      password: '',
      repeatPassword: '',
      errorMessage: null,
    };
  },

  validations: {

    password: {
      required,
      minLength: minLength(8),
      strongPassword,
    },

    repeatPassword: {
      sameAsPassword: sameAs('password'),
    },

    isValidPass: ['password', 'repeatPassword'],

  },

  computed: {
    ...mapGetters({
      currUser: 'app/currentUser',
      currClient: 'app/currentClient',
    }),
  },

  created() {
    this.email = this.currUser.email;
    this.mobile = this.currUser.mobile;
    this.name = this.currUser.name;
  },

  methods: {
    getClientLogo() {
      return this.currClient.logo_buffer;
    },
    async changePassword() {
      this.$v.isValidPass.$touch();
      if (this.$v.isValidPass.$anyDirty && this.$v.isValidPass.$invalid) {
        return;
      }
      const password = this.password;
      const data = { password };
      try {
        const { result, errMsg } = await this.$store.dispatch('app/changeProfile', { data });
        if (result) {
          const optimaHeaders = localStorage.getItem('Optima-selected-headers');
          this.$store.dispatch('app/logout');
          if (optimaHeaders) {
            localStorage.setItem('Optima-selected-headers', optimaHeaders);
          }
          localStorage.setItem('tsm-user-token', '');
          this.$router.push({ name: 'Login' });
          this.errorMessage = null;
        } else {
          this.errorMessage = errMsg;
          this.$errorMessage({ message: errMsg });
        }
      } catch (err) {
        // return err; // eslint-disable-line rule
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.order-details-wrapper {
    background: #fff;
    padding: 20px;
    min-height: 500px;
    box-shadow: 0 2px 4px 0 #ECECEC;
}
.profile-save-btn {
  float: right;
  margin-right: 23px;
  margin-top: 8px;
}
.error {
  color: #f57f6c;
  font-size: 1rem;
  font-weight: normal;
}
.password-note {
  margin-top: 20px;
}
.profile {
    &-name {
        width: 155px;
        height: 155px;
        background-color: #EEF2F4;
        border-radius: 50%;
        text-align: center;
        line-height: 155px;
        color: #008AFF;
        font-size: 3.0rem;
        font-weight: normal;
    }
    .card {
        &-row {
            &-edit {
                border-bottom: 1px solid #F0F0F0;
                box-shadow: none;
                padding: 20px 0 40px;
            }
        }
        &-edit {
            border: 1px solid transparent;
            input {
                width: 100%;
            }
            &-content {
                .grid {
                    padding: 0 50px;
                    border-right: 1px solid #CDCDCD;
                    &-col {
                      margin-bottom: 30px;
                        input {
                          margin-bottom: 8px;
                        }
                        &:last-child {
                            input {
                                margin-bottom: 0;
                            }
                        }
                    }
                    &:last-child {
                        border-right: 1px solid transparent;
                    }
                }
            }
        }
    }
}
</style>
